import type { FC } from 'react';
import React, { useContext, useCallback } from 'react';

import Button from '@atlaskit/button/custom-theme-button';

import {
	DISCOVER_ITEM_ON_HOME_PAGE_CLICK,
	setViewTransitionSource,
} from '@confluence/browser-metrics';

import { FeedCardContext } from './FeedCardContext';

const fullSizeButtonTheme = (currentTheme, themeProps) => {
	const { buttonStyles, spinnerStyles } = currentTheme(themeProps);
	return {
		buttonStyles: {
			...buttonStyles,
			position: 'absolute',
			top: '0px',
			left: '0px',
			width: '100%',
			height: '100%',
		},
		spinnerStyles,
	};
};

// It is invalid (and not accessible) to put an html button/link inside another button.
// so to make the full card clickable without nesting buttons, we style it absolute and full size.
type Props = {
	href: string;
	contentType?: string;
};
export const FeedCardInvisibleFullSizedLink: FC<Props> = ({ href, contentType }) => {
	const { fireAnalyticsEvent } = useContext(FeedCardContext);

	const handleClick = useCallback(() => {
		if (contentType && contentType === 'page') {
			setViewTransitionSource(DISCOVER_ITEM_ON_HOME_PAGE_CLICK);
		}
		fireAnalyticsEvent({
			type: 'sendUIEvent',
			action: 'clicked',
			actionSubject: 'link',
			actionSubjectId: 'feedCard',
			includeNavdex: true,
		});
	}, [fireAnalyticsEvent, contentType]);

	return (
		<Button
			href={href}
			appearance="link"
			theme={fullSizeButtonTheme}
			onClick={handleClick}
			testId="feed-card-body-link"
			aria-hidden
			tabIndex={-1}
		/>
	);
};
